import React, {FC} from 'react';

import {LegacyConversationLinkDropdownEntryPointInstance} from '../../../helpers/models/legacyApplicationHelpers';
import {ConversationBaseModel, ConversationModel} from '../../../models/api/conversationModel';
import {CellsContext} from '../../../store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../store/panels/panelStateBase';
import {LegacyConversationsApplicationContextHostContainer} from './legacyConversationsApplicationContextHostContainer';

/*
 * Props.
 */

interface LegacyConversationsApplicationContextInstanceHostProps {
  entryPointInstance: LegacyConversationLinkDropdownEntryPointInstance;
  onlyConversation: ConversationModel | undefined;
  conversations: ReadonlyArray<ConversationBaseModel>;
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
}

/*
 * Component.
 */

export const LegacyConversationsApplicationContextInstanceHost: FC<
  LegacyConversationsApplicationContextInstanceHostProps
> = (props) => {
  const {entryPointInstance, onlyConversation, conversations, panelId, cellsContext} = props;
  return (
    <LegacyConversationsApplicationContextHostContainer
      key={entryPointInstance.id}
      entryPoint={entryPointInstance.entryPoint}
      onlyConversation={onlyConversation}
      conversations={conversations}
      panelId={panelId}
      cellsContext={cellsContext}
    />
  );
};
